var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card" }, [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [_c("span", { staticClass: "headerText" }, [_vm._v("路由总览")])]
    ),
    _c(
      "div",
      {},
      [
        _c("el-tree", {
          attrs: {
            data: _vm.list,
            "node-key": "id",
            "default-expand-all": "",
            "expand-on-click-node": false
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var node = ref.node
                return _c("span", { staticClass: "custom-tree-node" }, [
                  _c("span", [_vm._v(_vm._s(node.label))]),
                  _c("div", [
                    _c("span", [
                      _vm._v(_vm._s(node.data.currentUrl.substr(1)) + " ")
                    ]),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "clipboard",
                            rawName: "v-clipboard:copy",
                            value: node.data.currentUrl.substr(1),
                            expression: "node.data.currentUrl.substr(1)",
                            arg: "copy"
                          },
                          {
                            name: "clipboard",
                            rawName: "v-clipboard:success",
                            value: _vm.clipboardSuccess,
                            expression: "clipboardSuccess",
                            arg: "success"
                          }
                        ],
                        staticClass: "copy"
                      },
                      [_vm._v("复制")]
                    )
                  ])
                ])
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }